import {translate} from "../../utils";

export default class GalleryItem extends PIXI.Container {
    constructor(texture) {
        super();
        this._image = new PIXI.Sprite(texture);
        this._image.anchor.set(0.5);
        this._image.scale.set(0.35);
        this.addChild(this._image);
    }
}